import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import Select from "react-select";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

import { getReturnRequests, getReturnRequestStatuses, updateReturnRequestOne } from "services/apiSupply";
import useQuery from "utils/useQuery";
import { Pagination } from "components/Pagination";
import { MySpinner } from "components/MySpinner";
import { useUser } from "features/Users/UserContext";
import { colorStyles, selectedStatuses } from "utils/select2";
import { SelectCustomer } from "features/Dashboard/SelectCustomer";
import { ReturnRequestsTable } from "features/ReturnRequests/ReturnRequestsTable";
import { toast } from "react-toastify";
import { dateFormatU } from "utils/format";

registerLocale("ru", ru);

export const ReturnRequestsPage = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const query = useQuery(useLocation);
  const [loading, setLoading] = useState(false);
  const { admins } = useUser();
  const [statuses, setStatuses] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    query.get("page") ? Number(query.get("page")) : 1
  );
  const getPageSize = localStorage.getItem("pageSize") ? JSON.parse(localStorage.getItem("pageSize")) : {};
  const [pageSize, setPageSize] = useState(getPageSize[pathname] || 10);
  const [customer, setCustomer] = useState(
    query.get("customer")
      ? { label: query.get("customerName"), value: query.get("customer") }
      : null
  );
  const [returnRequests, setReturnRequests] = useState([]);
  const [returnRequestsCount, setReturnRequestsCount] = useState(0);
  const [search, setSearch] = useState(query.get("search") || "");
  const [dateStart, setDateStart] = useState(
    query.get("dateStart")
      ? new Date(query.get("dateStart"))
      : moment().startOf('year').toDate()
  );
  const [dateEnd, setDateEnd] = useState(
    query.get("dateEnd") ? new Date(query.get("dateEnd")) : ""
  );
  const [filterStatus, setFilterStatus] = useState(
    localStorage.getItem("filterStatusReturnRequest")
      ? JSON.parse(localStorage.getItem("filterStatusReturnRequest"))
      : []
  );
  const [number, setNumber] = useState(query.get("number") || "");
  const [isShowReset, setIsShowReset] = useState(false);
  const [admin, setAdmin] = useState(
    localStorage.getItem("filterAdminReturnRequest")
      ? JSON.parse(localStorage.getItem("filterAdminReturnRequest"))
      : null
  );

  const getAndSetRequests = () => {
    getReturnRequests({
      "pagination[count]": pageSize,
      "pagination[offset]": (currentPage - 1) * pageSize,
      dateStart: dateFormatU(dateStart),
      dateEnd: dateFormatU(dateEnd),
      number,
      admin: admin?.value,
      article: search,
      customer: customer?.value,
      status: filterStatus.map((val) => val.value)
    })
      .then((res) => {
        setReturnRequests(res.items || []);
        setReturnRequestsCount(res.totalItems);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }

  const numberHandler = (e) => {
    setNumber(e.target.value.replace(/[^+\d]/g, ""));
  };

  const statusesList = () => {
    return statuses.map((val) => {
      return {
        label: val.name,
        value: val.id,
        color: val.color,
      };
    });
  };

  const searchHandler = () => {
    if (!isSearch()) return;
    if (currentPage !== 1) {
      setCurrentPage(1);
      return;
    }
    setLoading(true);
    getAndSetRequests();
  };

  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      searchHandler();
    }
  };

  const isSearch = () => {
    if (
      search ||
      dateStart ||
      dateEnd ||
      number ||
      customer?.value ||
      admin?.value,
      filterStatus
    ) {
      return true;
    }
    return false;
  };

  const getAndSetStatuses = () => {
    getReturnRequestStatuses()
      .then((res) => {
        setStatuses(res);
      })
      .catch((e) => console.error(e));
  };

  useEffect(() => {
    getAndSetStatuses();
  }, []);

  useEffect(() => {
    setLoading(true);
    getAndSetRequests();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize]);

  const selectHandler = (val, res) => {
    switch (res.name) {
      case "admin":
        localStorage.setItem("filterAdminReturnRequest", JSON.stringify(val));
        setAdmin(val);
        break;
      case "status":
        localStorage.setItem("filterStatusReturnRequest", JSON.stringify(val));
        setFilterStatus(val);
        break;
      default:
        break;
    }
  };

  const resetFilter = () => {
    setCustomer(null);
    setSearch("");
    setDateStart("");
    setDateEnd("");
    setNumber("");
    setAdmin(null);
    setFilterStatus([]);
    localStorage.removeItem("filterAdminReturnRequest");
    localStorage.removeItem("filterStatusReturnRequest");
  };

  useEffect(() => {
    setIsShowReset(isSearch());
    if (!isSearch()) {
      setLoading(true);
      getAndSetRequests();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    search,
    dateStart,
    dateEnd,
    number,
    customer,
    admin,
    filterStatus
  ]);

  const rowEvents = {
    onClick: (e, row) => {
      history.push(`/sales/returnRequest/${row.id}`);
    },
  };

  const statusHandler = (id, status) => {
    setLoading(true);
    updateReturnRequestOne(id, {
      status: status.id
    })
      .then((res) => {
        getAndSetRequests();
        toast.success("Статус успешно изменен");
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  }

  return (
    <Container fluid className="p-0 return-requests">
      {loading && <MySpinner overlay />}
      <Card className="mb-0 filter">
        <CardBody>
          <h1 className="h3 mb-3">Заявки на возврат</h1>

          <Form className="mb-3">
            <Row>
              <Col md={3}>
                <Label>Дата</Label>
                <InputGroup className="daterange">
                  <DatePicker
                    placeholderText="от"
                    selected={dateStart}
                    onChange={setDateStart}
                    selectsStart
                    startDate={dateStart}
                    endDate={dateEnd}
                    dateFormat="dd.MM.yyyy"
                    locale="ru"
                    className="form-control date-start"
                  />
                  <DatePicker
                    placeholderText="до"
                    selected={dateEnd}
                    onChange={setDateEnd}
                    selectsEnd
                    startDate={dateStart}
                    endDate={dateEnd}
                    minDate={dateStart}
                    dateFormat="dd.MM.yyyy"
                    locale="ru"
                    className="form-control date-end"
                  />
                </InputGroup>
              </Col>
              <Col md={2}>
                <Label>Заявка №</Label>
                <Input
                  name="number"
                  placeholder="По номеру"
                  value={number}
                  onChange={numberHandler}
                  onKeyUp={handleKeypress}
                />
              </Col>
              <Col md={2}>
                <Label>Артикул</Label>
                <Input
                  name="search"
                  placeholder="По артикулу"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyUp={handleKeypress}
                />
              </Col>
              <Col md={2}>
                <Label>Менеджер</Label>
                <Select
                  name="admin"
                  placeholder="Менеджер"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  options={admins}
                  value={admin}
                  onChange={selectHandler}
                  isClearable
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Label>Статус</Label>
                <Select
                  isMulti
                  name="status"
                  placeholder="Статус"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  options={statusesList()}
                  value={selectedStatuses(statuses, filterStatus)}
                  onChange={selectHandler}
                  styles={colorStyles}
                />
              </Col>
              <Col md={3}>
                <Label>Клиент</Label>
                <SelectCustomer customer={customer} setCustomer={setCustomer} />
              </Col>
              <Col md={2}>
                <InputGroup className="with-label">
                  {isShowReset && (
                    <Button color="danger" onClick={() => resetFilter()}>
                      <FontAwesomeIcon icon={faWindowClose} />
                    </Button>
                  )}
                  <Button
                    color="primary"
                    onClick={searchHandler}
                    className="button-wide"
                  >
                    Поиск
                  </Button>
                </InputGroup>
              </Col>
            </Row>
          </Form>

          <Row>
            <Col md="2">
              <Link
                to={`/sales/returnRequest/new`}
                color="primary"
                className="button-wide btn btn-primary"
              >
                Добавить заявку
              </Link>
            </Col>
          </Row>

        </CardBody>
      </Card>

      <div>
        <ReturnRequestsTable
          returnRequests={returnRequests}
          rowEvents={rowEvents}
          statuses={statuses}
          statusHandler={statusHandler}
        />

        <Card>
          <CardBody>
            <Pagination
              totalCount={returnRequestsCount}
              currentPage={currentPage}
              pageSize={pageSize}
              setCurrentPage={setCurrentPage}
              onChangePageSize={setPageSize}
            />
          </CardBody>
        </Card>
      </div>
    </Container>
  )
}